import { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate, useParams } from "react-router-dom";

import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";

import {
  getLangAll,
  getCountries,
  putPriceCountries,
  postPriceCountries,
  deletePriceCountries,
} from "../../store/middleware";
import Header from "../../components/Header/NewHeader";
import SideMenu from "../../components/SideMenu/SideMenu";
import { decryptIfEncrypted } from "../../utils/fieldDecryptor";
import Engrenagem from "../../assets/images/icons/icon_settings_header.svg";

import { Language } from "./styles";

function NewCountries() {
  let { id } = useParams();
  let { state } = useLocation();
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { allLingos } = useSelector((state) => state.genericReducer);

  const [open, setOpen] = useState(false);
  const [isDelete, setIsDelete] = useState(false);
  const [dialogMsg, setDialogMsg] = useState("");
  const [dialogTitle, setDialogTitle] = useState("");
  const [countries, setCountries] = useState([]);
  const [form, setForm] = useState({
    countryId: 0,
    active: false,
    paymentMethod: "",
    lingoLanguageId: 0,
    standardCurrency: "",
    defaultCountry: false,
    extraClassPercentage: "",
  });

  const getData = async () => {
    await dispatch(getLangAll());
    await dispatch(getCountries()).then((res) => setCountries(res));

    getCountryData();
  };

  const getCountryData = () => {
    if (id) {
      setForm({
        countryId: state?.data?.countryId,
        lingoLanguageId: state?.data?.lingoLanguageId,
        paymentMethod: state?.data?.paymentMethod,
        standardCurrency: state?.data?.standardCurrency,
        extraClassPercentage: state?.data?.extraClassPercentage,
        defaultCountry: state?.data?.defaultCountry,
        active: state?.data?.active,
      });
    }
  };

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    const newValue = type === "checkbox" ? checked : value;
    setForm((state) => ({ ...state, [name]: newValue }));
  };

  const validateForm = () => {
    if (form.countryId === 0) {
      setOpen(true);
      setDialogMsg("COUNTRY_REQUIRED");
      setDialogTitle("ERROR");
      return false;
    }

    if (form.lingoLanguageId === 0) {
      setOpen(true);
      setDialogMsg("LANGUAGE_REQUIRED");
      setDialogTitle("ERROR");
      return false;
    }

    if (form.paymentMethod === "" || form.paymentMethod === undefined) {
      setOpen(true);
      setDialogMsg("PAYMENT_REQUIRED");
      setDialogTitle("ERROR");
      return false;
    }

    if (form.standardCurrency === "" || form.standardCurrency.length !== 3) {
      setOpen(true);
      setDialogMsg("CURRENCY_REQUIRED_OR_INVALID");
      setDialogTitle("ERROR");
      return false;
    }

    if (form.standardCurrency === "" || form.standardCurrency.length !== 3) {
      setOpen(true);
      setDialogMsg("CURRENCY_REQUIRED_OR_INVALID");
      setDialogTitle("ERROR");
      return false;
    }

    return true;
  };

  const handlePost = () => {
    if (validateForm()) {
      let sendObj = {
        countryId: Number(form.countryId),
        lingoLanguageId: Number(form.lingoLanguageId),
        paymentMethod: form.paymentMethod,
        standardCurrency: form.standardCurrency,
        extraClassPercentage: Number(form.extraClassPercentage),
        defaultCountry: form.defaultCountry,
        active: form.active,
      };

      if (!id) {
        dispatch(postPriceCountries(sendObj))
          .then(() => navigate(-1))
          .catch((err) => {
            let errMsg =
              err.response.data.error.errors[0].message !== undefined
                ? err.response.data.error.errors[0].message
                : err.data.errors[0].message;
            setOpen(true);
            setDialogTitle("Ops!");
            setDialogMsg(errMsg);
          });
      } else {
        dispatch(putPriceCountries(id, sendObj))
          .then(() => navigate(-1))
          .catch((err) => {
            let errMsg =
              err.response.data.error.errors[0].message !== undefined
                ? err.response.data.error.errors[0].message
                : err.data.errors[0].message;
            setOpen(true);
            setDialogTitle("Ops!");
            setDialogMsg(errMsg);
          });
      }
    }
  };

  const handleDelete = (e) => {
    e.preventDefault();

    setOpen(true);
    setIsDelete(true);
    setDialogMsg(`Are you sure you want do delete country ${state?.data.country?.name} ?`);
    setDialogTitle("Delete");
  };

  const callDeleteApi = () => {
    dispatch(deletePriceCountries(id))
      .then(() => {
        navigate(-1);
        setOpen(false);
      })
      .catch((err) => {
        setOpen(true);
        setDialogTitle("Ops!");
        setDialogMsg(err.message);
      });
  };

  useEffect(() => {
    getData();
    // eslint-disable-next-line
  }, []);

  return (
    <div className="view">
      <SideMenu />
      <section>
        <Header t={t} title="Countries" icon={<img src={Engrenagem} alt="Engrenagem" />} typeIcon="custom" />

        <div className="content">
          <Language>
            <div className="bigBox teste ">
              <h2>{!id ? "Add new Country" : decryptIfEncrypted(state?.data.country?.name)}</h2>

              <div className="planInfo">
                <form className="formulario">
                  <div className="country">
                    <div className="countryTop">
                      <div>
                        <label htmlFor="name">Country</label>
                        <span>Required</span>
                      </div>

                      <select
                        value={form.countryId}
                        onChange={handleChange}
                        name="countryId"
                        className="input-lingo"
                        disabled={countries.length === 1}
                      >
                        <option>Select</option>

                        {countries.map((country) => (
                          <option key={country.id} value={country.id}>
                            {country.name}
                          </option>
                        ))}
                      </select>
                    </div>

                    <div className="countryTop">
                      <div>
                        <label htmlFor="name">Country Language</label>
                        <span>Required</span>
                      </div>
                      <select
                        value={form.lingoLanguageId}
                        onChange={handleChange}
                        name="lingoLanguageId"
                        className="input-lingo"
                      >
                        <option>Select</option>

                        {allLingos?.map((lang) => (
                          <option key={lang.id} value={lang.id}>
                            {lang.language.name}
                          </option>
                        ))}
                      </select>
                    </div>
                  </div>

                  <div>
                    <div className="country">
                      <div className="countryTop">
                        <div>
                          <label htmlFor="name">Standard Payment</label>
                          <span>Required</span>
                        </div>

                        <select
                          value={form.paymentMethod}
                          onChange={handleChange}
                          name="paymentMethod"
                          className="input-lingo"
                        >
                          <option>Select</option>
                          <option value={"paypal"}>PayPal</option>
                        </select>
                      </div>

                      <div className="countryTop">
                        <div>
                          <label htmlFor="name">Standard Currency</label>
                          <span>Required</span>
                        </div>
                        <input
                          type="text"
                          value={form.standardCurrency}
                          onChange={handleChange}
                          name="standardCurrency"
                          placeholder="Enter Currency code"
                          maxLength="3"
                        />
                      </div>
                    </div>
                    <div className="country">
                      <div className="countryTop">
                        <div>
                          <label htmlFor="name">{`${t("EXTRA_CLASS_PRICE")} - %`}</label>
                          <span>Required</span>
                        </div>
                        <input
                          value={form.extraClassPercentage}
                          onChange={handleChange}
                          name="extraClassPercentage"
                          className="input-lingo"
                          placeholder={t("ENTER_PERCENTAGE_VALUE")}
                        />
                      </div>
                    </div>

                    <label htmlFor="gender">Standard country?</label>
                    <div className="switchBox">
                      <div className="switch__container addInput">
                        <input
                          id="switch-shadow2"
                          className="switch switch--shadow"
                          name="defaultCountry"
                          type="checkbox"
                          checked={form.defaultCountry}
                          onChange={handleChange}
                        />
                        <label htmlFor="switch-shadow2">
                          <span>{form.defaultCountry ? "Yes" : "No"}</span>
                        </label>
                      </div>
                    </div>

                    <label htmlFor="gender">Active?</label>
                    <div className="switchBox">
                      <div className="switch__container addInput">
                        <input
                          id="switch-shadow3"
                          className="switch switch--shadow"
                          name="active"
                          type="checkbox"
                          checked={form.active}
                          onChange={handleChange}
                        />
                        <label htmlFor="switch-shadow3">
                          <span>{form.active ? "Yes" : "No"}</span>
                        </label>
                      </div>
                    </div>

                    {id && (
                      <Button onClick={handleDelete} className="deleteType">
                        Delete Country
                      </Button>
                    )}
                  </div>
                </form>
              </div>
            </div>
            <div className="button">
              <button className="back" onClick={() => navigate(-1)}>
                <i className="fa fa-angle-left" aria-hidden="true"></i>Back
              </button>
              <button className="save" onClick={handlePost}>
                Save
              </button>
            </div>

            <Dialog
              open={open}
              keepMounted
              onClose={() => setOpen(false)}
              aria-labelledby="alert-dialog-slide-title"
              aria-describedby="alert-dialog-slide-description"
            >
              <DialogTitle id="alert-dialog-slide-title">{dialogTitle}</DialogTitle>
              <DialogContent>
                <DialogContentText id="alert-dialog-slide-description">{dialogMsg}</DialogContentText>
              </DialogContent>
              <DialogActions>
                {isDelete && (
                  <Button onClick={callDeleteApi} color="primary">
                    Yes, delete
                  </Button>
                )}

                <Button onClick={() => setOpen(false)} color="primary">
                  Cancel
                </Button>
              </DialogActions>
            </Dialog>
          </Language>{" "}
        </div>
      </section>
    </div>
  );
}

export default NewCountries;
